export const CUSTOM_FIELDS_ORDERS_BACKEND_NAME = 'Orders CRUD module';

export const CUSTOM_FIELDS_FILTER = 'customFields';

export const CUSTOM_FIELDS_TYPES = {
  DATE_PICKER: 'DATE_PICKER',
  MULTI_SELECT_DROPDOWN: 'MULTI_SELECT_DROPDOWN',
  TEXTBOX_LONG: 'TEXTBOX_LONG',
  TEXTBOX_SHORT: 'TEXTBOX_SHORT',
};
